export const PROPERTY_NAMES = new Set([
  "leftContent",
  "rightContent",
  "buttons",
  "children",
  "content",
  "items",
  "header",
  "footer",
  "body",
]);

export const MAX_TREE_DEPTH = 100;

export const INVALID_DROP_I18N = "builder_ui.errors.invalid_element_drop";
